import css from "styled-jsx/css";

export const componentStyles = css`
  .colored-timer-vertical-tabs-component {
  }
`;
